import { Document, Font, Page, StyleSheet, Text, View } from "@react-pdf/renderer";
import React, {useEffect} from "react";
import PropTypes from "prop-types";



const styles = StyleSheet.create({
  page: {
    padding: 15,
    fontSize: 12,
    fontFamily: "Vazir",
    backgroundColor: "#fcfcfc",
  },
  wrapper: {
    marginBottom: 5,
  },
  receiptContainer: {
    border: "2pt solid #2c3e50",
    borderRadius: 10,
    backgroundColor: "#ffffff",
    overflow: "hidden",
  },
  headerSection: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#ecf0f1",
    padding: 8,
    borderBottom: "2pt solid #2c3e50",
  },
  headerRight: {
    flex: 1,
    alignItems: "flex-end",
  },
  headerCenter: {
    flex: 1,
    alignItems: "center",
  },
  headerLeft: {
    flex: 1,
    alignItems: "flex-start",
  },
  companyName: {
    fontSize: 20,
    fontWeight: "bold",
    color: "#2c3e50",
  },
  receiptTitle: {
    fontSize: 14,
    color: "#34495e",
    marginBottom: 3,
  },
  copyLabel: {
    fontSize: 13,
    fontWeight: "bold",
    backgroundColor: "#2c3e50",
    color: "#ffffff",
    paddingVertical: 3,
    paddingHorizontal: 10,
    borderRadius: 5,
  },
  headerText: {
    fontSize: 11,
    color: "#555",
    marginBottom: 2,
    direction: "rtl",
  },
  headerValue: {
    fontWeight: "bold",
    color: "#000",
    fontSize: 11,
  },
  bodySection: {
    padding: 8,
    direction: "rtl",
  },
  infoGrid: {
    flexDirection: "row-reverse",
    flexWrap: "wrap",
    borderTop: "1.5pt solid #bdc3c7",
    borderRight: "1.5pt solid #bdc3c7",
  },
  infoCell: {
    width: "33.33%",
    padding: 6,
    borderBottom: "1.5pt solid #bdc3c7",
    borderLeft: "1.5pt solid #bdc3c7",
    flexDirection: "row-reverse",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  cellLabel: {
    fontSize: 11,
    color: "#7f8c8d",
  },
  colon: {
    fontSize: 11,
    color: "#7f8c8d",
    marginHorizontal: 4,
  },
  cellValue: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#2c3e50",
  },
  weightSection: {
    flexDirection: "row-reverse",
    marginTop: 8,
    border: "2pt solid #2c3e50",
    borderRadius: 8,
    overflow: "hidden",
  },
  weightBox: {
    flex: 1,
    alignItems: "center",
    borderLeft: "1.5pt solid #2c3e50",
  },
  weightBoxLast: {
    flex: 1,
    alignItems: "center",
  },
  weightTitle: {
    width: "100%",
    textAlign: "center",
    backgroundColor: "#ecf0f1",
    paddingVertical: 4,
    fontSize: 12,
    fontWeight: "bold",
    color: "#2c3e50",
    borderBottom: "1.5pt solid #2c3e50",
  },
  weightValue: {
    paddingVertical: 6,
    fontSize: 16,
    fontWeight: "bold",
  },
  netWeightValue: {
    paddingVertical: 6,
    fontSize: 18,
    fontWeight: "bold",
    color: "#27ae60",
  },
  addressSection: {
    marginTop: 8,
    padding: 6,
    backgroundColor: "#f9f9f9",
    borderRadius: 6,
    border: "1.5pt dashed #bdc3c7",
  },
  addressText: {
    fontSize: 10,
    textAlign: "center",
    direction: "rtl",
    color: "#555",
  },
  signatureSection: {
    flexDirection: "row-reverse",
    justifyContent: "space-around",
    marginTop: 10,
    marginBottom: 4,
  },
  signatureBox: {
    alignItems: "center",
    width: "30%",
  },
  signatureLine: {
    width: "80%",
    borderBottom: "1.5pt solid #7f8c8d",
    marginBottom: 4,
  },
  signatureText: {
    fontSize: 10,
    color: "#7f8c8d",
  },
  cutLine: {
    borderTop: "1.5pt dashed #95a5a6",
    marginVertical: 22,
    width: "100%",
    position: "relative",
  },
  scissorsIcon: {
    position: "absolute",
    top: -8,
    left: "50%",
    backgroundColor: "#fcfcfc",
    paddingHorizontal: 8,
    fontSize: 12,
    color: "#95a5a6",
  },
  softwareFooter: {
    textAlign: "center",
    fontSize: 9,
    color: "#95a5a6",
    marginTop: 4,
    direction: "rtl",
  },
  pelakContainer: {
    flexDirection: "row",
    border: "1.5pt solid #000",
    borderRadius: 4,
    height: 28,
    backgroundColor: "#fff",
    alignItems: "center",
    overflow: "hidden",
    direction: "ltr",
  },
  pelakBlueStrip: {
    width: 10,
    backgroundColor: "#003399",
    height: "100%",
  },
  pelakMain: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 5,
    direction: "ltr",
  },
  pelakDivider: {
    borderLeft: "1.5pt solid #000",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 5,
    direction: "ltr",
  },
  pelakIranLabel: {
    fontSize: 6,
    marginBottom: 1,
  },
  pelakText: {
    fontSize: 13,
    fontWeight: "bold",
    marginHorizontal: 2,
    color: "#000",
  }
});

const PdfReceiptWeight = ({ data }) => {
  useEffect(() => {
    Font.register({
      family: "Vazir",
      src: "/fonts/Vazirmatn-FD-Medium.ttf",
    });
  }, []);
  const chunkArray = (array, size) => {
    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const pages = chunkArray(data, 2);

  const parsePelak = (pelak) => {
    if (!pelak) return null;
    const part1 = pelak.slice(0, 2);
    const part2 = pelak.slice(2, 3);
    const part3 = pelak.slice(3, 6);
    const part4 = pelak.slice(6);
    return { part1, part2, part3, part4 };
  };

  const transformItem = (item) => {
    return {
      cargo_code: item.cargo_code,
      type: item.type_full || item.type,
      date: item.created_at,
      weight_fill: item.weight_fill,
      weight_empty: item.weight_empty,
      machine: {
        type: item.machine?.type,
        name: item.machine?.name,
      },
      driver: item.driver,
      jens: {
        value: item.jens,
      },
      plate: item.plate,
      destination: {
        title: item.destination,
      },
      origin: {
        title: item.origin,
      },
      buyer_name: item.buyer_name,
    };
  };

  const getOperationType = (type) => {
    if (type === "1" || type === 1) return "بارگیری";
    if (type === "2" || type === 2) return "تخلیه";
    return type || '--';
  };

  const formatTime = (dateStr) => {
    if (!dateStr) return '--';
    if (dateStr.includes('T')) return dateStr.split('T')[1]?.split('.')[0] || '--';
    if (dateStr.includes(' ')) return dateStr.split(' ')[1] || '--';
    return '--';
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '--';
    let cleanDate = dateStr.includes('T') ? dateStr.split('T')[0] : (dateStr.includes(' ') ? dateStr.split(' ')[0] : dateStr);
    const parts = cleanDate.split('-');
    if (parts.length === 3) return `${parts[0]}/${parts[1]}/${parts[2]}`;
    return cleanDate;
  };

  return (
    <Document>
      {pages.map((pageItems, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          {pageItems.map((item, ind) => {
            console.log(item)
            const trItem = transformItem(item);
            const pelak = parsePelak(trItem.plate);
            const netWeight = trItem.weight_fill && trItem.weight_empty ? Math.abs(trItem.weight_fill - trItem.weight_empty) : '--';

            return (
              <View style={styles.wrapper} key={ind}>
                {[...Array(2)].map((_, idx) => (
                  <React.Fragment key={idx}>
                    {idx > 0 && (
                      <View style={styles.cutLine}>
                        <Text style={styles.scissorsIcon}>✂ محل برش</Text>
                      </View>
                    )}

                    <View style={styles.receiptContainer}>
                      <View style={styles.headerSection}>
                        <View style={styles.headerRight}>
                          <View style={{ flexDirection: "row-reverse", marginBottom: 2 }}>
                            <Text style={styles.headerValue}>شماره قبض : {trItem.cargo_code || '--'}</Text>
                          </View>
                          <View style={{ flexDirection: "row-reverse", marginBottom: 2 }}>
                            <Text style={styles.headerValue}>تاریخ : {formatTime(trItem.date)} {formatDate(trItem.date)}</Text>
                          </View>
                        </View>

                        <View style={styles.headerCenter}>
                          <Text style={styles.receiptTitle}>قبض باسکول</Text>
                          <Text style={styles.companyName}>مشعل بام سینا</Text>
                        </View>

                        <View style={styles.headerLeft}>
                          <Text style={styles.copyLabel}>نسخه {idx === 1 ? "راننده" : "بایگانی"}</Text>
                        </View>
                      </View>

                      <View style={styles.bodySection}>
                        <View style={styles.infoGrid}>
                          <View style={styles.infoCell}>
                            <Text style={styles.cellLabel}>نوع ماشین</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.cellValue}>{trItem.machine?.name ?? '--'}</Text>
                          </View>
                          <View style={styles.infoCell}>
                            <Text style={styles.cellLabel}>پلاک</Text>
                            <Text style={styles.colon}>:</Text>
                            {pelak ? (
                              <View style={styles.pelakContainer}>
                                <View style={styles.pelakBlueStrip} />
                                <View style={styles.pelakMain}>
                                  <Text style={styles.pelakText}>{pelak.part1}</Text>
                                  <Text style={styles.pelakText}>{pelak.part2}</Text>
                                  <Text style={styles.pelakText}>{pelak.part3}</Text>
                                </View>
                                <View style={styles.pelakDivider}>
                                  <Text style={styles.pelakIranLabel}>ایران</Text>
                                  <Text style={styles.pelakText}>{pelak.part4}</Text>
                                </View>
                              </View>
                            ) : (
                              <Text style={styles.cellValue}>--</Text>
                            )}
                          </View>
                          <View style={styles.infoCell}>
                            <Text style={styles.cellLabel}>نام راننده</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.cellValue}>{trItem.driver ?? '--'}</Text>
                          </View>
                          <View style={styles.infoCell}>
                            <Text style={styles.cellLabel}>نوع کالا</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.cellValue}>{trItem.jens?.value ?? '--'}</Text>
                          </View>

                          <View style={styles.infoCell}>
                            <Text style={styles.cellLabel}>مبدأ</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.cellValue}>{trItem.origin?.title || '--'}</Text>
                          </View>
                          <View style={styles.infoCell}>
                            <Text style={styles.cellLabel}>مقصد</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.cellValue}>{trItem.destination?.title || '--'}</Text>
                          </View>
                          <View style={styles.infoCell}>
                            <Text style={styles.cellLabel}>نام مشتری</Text>
                            <Text style={styles.colon}>:</Text>
                            <Text style={styles.cellValue}>{trItem.buyer_name ?? '--'}</Text>
                          </View>


                          {/*<View style={styles.infoCell}>*/}
                          {/*  <Text style={styles.cellLabel}>نوع دستگاه</Text>*/}
                          {/*  <Text style={styles.colon}>:</Text>*/}
                          {/*  <Text style={styles.cellValue}>{trItem.machine?.type ?? '--'}</Text>*/}
                          {/*</View>*/}

                        </View>

                        <View style={styles.weightSection}>
                          <View style={styles.weightBox}>
                            <Text style={styles.weightTitle}>وزن خالی (KG)</Text>
                            <Text style={styles.weightValue}>{trItem.weight_empty ?? '--'}</Text>
                          </View>
                          <View style={styles.weightBox}>
                            <Text style={styles.weightTitle}>وزن پر (KG)</Text>
                            <Text style={styles.weightValue}>{trItem.weight_fill ?? '--'}</Text>
                          </View>

                          <View style={styles.weightBoxLast}>
                            <Text style={styles.weightTitle}>وزن خالص (KG)</Text>
                            <Text style={styles.netWeightValue}>{netWeight}</Text>
                          </View>
                        </View>

                        <View style={styles.addressSection}>
                          <Text style={styles.addressText}>
                            آدرس: ارومیه - جاده سرو - کیلومتر 20 شهرک آسفالت | تلفن: 09901868379 - 09141869663
                          </Text>
                        </View>

                        <View style={styles.signatureSection}>
                          <View style={styles.signatureBox}>
                            <View style={styles.signatureLine} />
                            <Text style={styles.signatureText}>امضای تحویل گیرنده</Text>
                          </View>
                          <View style={styles.signatureBox}>
                            <View style={styles.signatureLine} />
                            <Text style={styles.signatureText}>امضای تحویل دهنده</Text>
                          </View>
                          <View style={styles.signatureBox}>
                            <View style={styles.signatureLine} />
                            <Text style={styles.signatureText}>امضای متصدی باسکول</Text>
                          </View>
                        </View>

                      </View>
                    </View>
                  </React.Fragment>
                ))}
                <Text style={styles.softwareFooter}>
                  نرم افزار مدیریت بارگیری بارگو | 021-91096293 | www.bargosoftware.com
                </Text>
              </View>
            );
          })}
        </Page>
      ))}
    </Document>
  );
};

PdfReceiptWeight.propTypes = {
  data: PropTypes.array,
};

export default PdfReceiptWeight;
